import { render, staticRenderFns } from "./AGCCard.vue?vue&type=template&id=4a48e4e7&scoped=true&"
import script from "./AGCCard.vue?vue&type=script&lang=js&"
export * from "./AGCCard.vue?vue&type=script&lang=js&"
import style0 from "./AGCCard.vue?vue&type=style&index=0&id=4a48e4e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a48e4e7",
  null
  
)

export default component.exports